import React from 'react';
import { App, loader as appLoader } from '../App';
import { Login, ForgotPassword, ResetPassword } from '@enrich/shared-lib';
import ErrorPage from '../pages/Error/ErrorPage';
import {
    SearchStudents,
    loader as searchLoader,
} from '../pages/Search/SearchStudents';
import { contactLoader } from '@enrich/shared-lib';
import { jobSummaryLoader as jobLoader } from '@enrich/shared-lib';
import {
    Dashboard,
    loader as dashboardLoader,
} from '../pages/Dashboard/Dashboard';
import {
    CompanyProfile,
    loader as companyLoader,
} from '../pages/Company/CompanyProfile';
import {
    CompanyCandidates,
    loader as companyCandidatesLoader,
} from '../pages/Company/CompanyCandidates';
import { Applicants } from '../pages/Applications/Applicants';
import {
    RoleAwareContactProfile,
    RoleAwareJobSummary,
    RoleAwareJobsDashboard,
} from './welcomeCallCoachAccess';
import {
    NewJobForm,
    loader as newJobFormLoader,
} from '../pages/Jobs/NewJobForm';
import { RecentApprovals } from '../pages/Applications/RecentApprovals';
import {
    NewCompanyForm,
    loader as newCompanyFormLoader,
} from '../pages/Company/NewCompanyForm';
import {
    EditJobForm,
    loader as editJobLoader,
} from '../pages/Jobs/EditJobForm';
import {
    ContactList,
    loader as contactListLoader,
} from '../pages/ContactLists/ContactList';
import { ListsDashboard } from '../pages/ContactLists/ListsDashboard';
import {
    ReferralsDashboard,
    loader as referralsLoader,
} from '../pages/Referrals/ReferralsDashboard';
import { ResumeDashboard } from '../pages/ResumeReview/ResumeDashboard';
import { InternalReviewDashboard } from '../pages/InternalReview/InternalReviewDashboard';
import {
    Conversation,
    loader as conversationLoader,
} from '../pages/Conversations/Conversation';
import {
    ContactConversations,
    contactConversationsLoader,
} from '@enrich/shared-lib';
import {
    SchoolProfile,
    loader as schoolProfileLoader,
} from '../pages/Schools/SchoolProfile';
import { SchoolsDashboard } from '../pages/Schools/SchoolsDashboard';
import { CandidacySummary, candidacyLoader } from '@enrich/shared-lib';
import {
    JobClosedCandidacies,
    loader as jobClosedCandidaciesLoader,
} from '../pages/Jobs/JobClosedCandidacies';
import {
    loader as schoolProfileInactiveLoader,
    SchoolNonActiveStudents,
} from '../pages/Schools/SchoolStudentsInactive';
import {
    SchoolActiveStudents,
    loader as schoolActiveStudentsLoader,
} from '../pages/Schools/SchoolActiveStudents';
import {
    SchoolAllStudents,
    loader as schoolAllStudentsLoader,
} from '../pages/Schools/SchoolAllStudents';
import {
    SchoolAlumniStudents,
    loader as schoolAlumniStudentsLoader,
} from '../pages/Schools/SchoolAlumniStudents';
import {
    PipelineSummary,
    loader as pipelineSummaryLoader,
} from '../pages/Pipelines/PipelineSummary';
import {
    ResumeReviewerHistory,
    loader as resumeReviewerHistoryLoader,
} from '../pages/InternalReview/ResumeReviewerHistory';
import {
    ExternalReporting,
    loader as externalReportingLoader,
} from '../pages/InternalReview/ExternalReporting/ExternalReporting';
import {
    CadiCurriculums,
    loader as cadiCurriculumsLoader,
} from '../pages/InternalReview/CadiCurriculums/CadiCurriculums';
import {
    PipelineDashboard,
    pipelineDashboardLoader,
} from '../pages/Pipelines/PipelineDashboard';
import { ClosedJobs } from '../pages/Jobs/ClosedJobs';
import {
    TasksDashboard,
    loader as tasksDashboardLoader,
} from '../pages/Tasks/TasksDashboard';
import { CompaniesDashboard } from '../pages/Company/CompaniesDashboard';
import { InviteAdmin, inviteAdminLoader } from '../pages/Invite/InviteAdmin';
import {
    WelcomeCalls,
    welcomeCallsLoader,
} from '../pages/WelcomeCalls/WelcomeCalls';
import {
    ChangePassword,
    changePasswordLoader,
} from '../pages/ChangePassword/ChangePassword';

const routes = [
    {
        path: '/',
        element: <App />,
        loader: appLoader,
        children: [
            {
                path: '/applicants',
                element: <Applicants />,
            },
            {
                path: '/approvals',
                element: <RecentApprovals />,
            },
            {
                path: '/dashboard',
                element: <Dashboard />,
                loader: dashboardLoader,
            },
            {
                path: '/jobs',
                element: <RoleAwareJobsDashboard showCompanyColumn showSearch />,
                handle: { welcomeCallCoach: true },
            },
            {
                path: '/resumes',
                element: <ResumeDashboard />,
                handle: { welcomeCallCoach: true },
            },
            {
                path: '/search',
                element: <SearchStudents />,
                loader: searchLoader,
                action: () => {},
            },
            {
                path: '/companies',
                element: <CompaniesDashboard />,
            },
            {
                path: '/companies/:companyId',
                element: <CompanyProfile />,
                loader: companyLoader,
                handle: { welcomeCallCoach: true },
            },
            {
                path: '/companies/:companyId/candidates',
                element: <CompanyCandidates />,
                loader: companyCandidatesLoader,
            },
            {
                path: '/companies/create',
                element: <NewCompanyForm />,
                loader: newCompanyFormLoader,
            },
            {
                path: '/contacts/:contactId',
                element: <RoleAwareContactProfile />,
                loader: contactLoader,
                handle: { welcomeCallCoach: true },
            },
            {
                path: '/contacts/:contactId/conversations',
                element: <ContactConversations />,
                loader: contactConversationsLoader,
            },
            {
                path: '/conversations/:conversationId',
                element: <Conversation />,
                loader: conversationLoader,
            },
            {
                path: '/jobs/:jobId',
                element: <RoleAwareJobSummary />,
                loader: jobLoader,
                handle: { welcomeCallCoach: true },
            },
            {
                path: '/jobs/:jobId/edit',
                element: <EditJobForm />,
                loader: editJobLoader,
            },
            {
                path: '/jobs/:jobId/closed',
                element: <JobClosedCandidacies />,
                loader: jobClosedCandidaciesLoader,
            },
            {
                path: '/jobs/closed',
                element: <ClosedJobs />,
            },
            {
                path: '/jobs/create',
                element: <NewJobForm />,
                loader: newJobFormLoader,
            },
            {
                path: '/lists',
                element: <ListsDashboard />,
            },
            {
                path: '/lists/:listId',
                element: <ContactList />,
                loader: contactListLoader,
            },
            {
                path: '/referrals',
                element: <ReferralsDashboard />,
                loader: referralsLoader,
            },
            {
                path: '/internal-review',
                element: <InternalReviewDashboard />,
                children: [
                    {
                        path: 'resume-reviewer-history',
                        element: <ResumeReviewerHistory />,
                        loader: resumeReviewerHistoryLoader,
                    },
                    {
                        path: 'reporting',
                        element: <ExternalReporting />,
                        loader: externalReportingLoader,
                    },
                    {
                        path: 'cadi',
                        element: <CadiCurriculums />,
                        loader: cadiCurriculumsLoader,
                    },
                ],
            },
            {
                path: '/schools',
                element: <SchoolsDashboard />,
            },
            {
                path: '/schools/:schoolId',
                element: <SchoolProfile />,
                loader: schoolProfileLoader,
            },
            {
                path: '/schools/:schoolId/active',
                element: <SchoolActiveStudents />,
                loader: schoolActiveStudentsLoader,
            },
            {
                path: '/schools/:schoolId/all',
                element: <SchoolAllStudents />,
                loader: schoolAllStudentsLoader,
            },
            {
                path: '/schools/:schoolId/alumni',
                element: <SchoolAlumniStudents />,
                loader: schoolAlumniStudentsLoader,
            },
            {
                path: '/schools/:schoolId/inactive',
                element: <SchoolNonActiveStudents />,
                loader: schoolProfileInactiveLoader,
            },
            {
                path: '/jobs/:jobId/candidacies/:candidacyId',
                element: <CandidacySummary />,
                loader: candidacyLoader,
                handle: { welcomeCallCoach: true },
            },
            {
                path: '/pipelines/:pipelineId',
                element: <PipelineSummary />,
                loader: pipelineSummaryLoader,
            },
            {
                path: '/pipelines',
                element: <PipelineDashboard />,
                loader: pipelineDashboardLoader,
            },
            {
                path: '/tasks',
                element: <TasksDashboard />,
                loader: tasksDashboardLoader,
            },
            {
                path: '/invite',
                element: <InviteAdmin />,
                loader: inviteAdminLoader,
            },
            {
                path: '/welcome-calls',
                element: <WelcomeCalls />,
                loader: welcomeCallsLoader,
                handle: { welcomeCallCoach: true },
            },
        ],
        errorElement: <ErrorPage />,
    },
    {
        path: '/login',
        element: <Login />,
        errorElement: <ErrorPage />,
    },
    {
        path: '/change-password',
        element: <ChangePassword />,
        loader: changePasswordLoader,
        errorElement: <ErrorPage />,
    },
    {
        path: '/forgot-password',
        element: <ForgotPassword />,
        errorElement: <ErrorPage />,
    },
    {
        path: '/reset-password',
        element: <ResetPassword />,
        errorElement: <ErrorPage />,
    },
];

export default routes;
